<template>
  <NuxtRouteAnnouncer />
  <v-app>
    <div class="text-center mt-16">
      <nuxt-link to="/">
        <img
          src="/wiresock-logo.png"
          width="165"
          height="23"
          title="Wiresock logo"
          alt="Wiresock logo"
        />
      </nuxt-link>
    </div>
    <v-main>
      <slot />
    </v-main>
    <v-footer
      class="d-flex align-center justify-center ga-2 flex-wrap flex-grow-1 py-3"
      color="surface-light"
    >

      <v-btn to="/" size="small" variant="plain">Main page</v-btn>
      <v-btn to="/documentation" size="small" variant="plain">Documentation</v-btn>
      <v-btn to="/about/contacts" size="small" variant="plain">Contacts</v-btn>
      <v-btn to="/about/terms-of-service" size="small" variant="plain">Terms of Service</v-btn>
      <v-btn to="/about/privacy-policy" size="small" variant="plain">Privacy Policy</v-btn>

      <div class="flex-1-0-100 text-center font-weight-light text-grey-darken-2">
        Copyright © Wiresock Foundation, 2021-{{ currentYear }}.
      </div>
    </v-footer>
  </v-app>
</template>
<script
  setup
  lang="ts"
>
const currentYear = new Date().getFullYear();
</script>
